import questionTypes from './types';

export const initialStates = {
	list: null,
	submittedReply: null,
};

const questionReducers = (state = initialStates, action) => {
	switch (action.type) {
		case questionTypes.LIST.SUCCESS: {
			return { ...state, list: action?.payload };
		}

		case questionTypes.LIST.CLEAR: {
			return { ...state, list: null };
		}

		case questionTypes.REPLY.SUCCESS: {
			return { ...state, submittedReply: action?.payload };
		}

		case questionTypes.REPLY.CLEAR: {
			return { ...state, submittedReply: null };
		}

		default:
			return state;
	}
};

export default questionReducers;
